import React from 'react';

function BillingTile({ children, className }) {
    return <div className={`billing-tile ${className}`}>
        {children}
    </div>;
}

export default BillingTile;
